import { FAILED_URLS } from "../lib/constants/actions";
export const failedUrls = (state = {}, action) => {
    switch (action.type) {
        case FAILED_URLS.GET_FAILED_URLS_SUCCESS:
            return { ...state, urls: action.payload }
        case FAILED_URLS.GET_FAILED_URLS_FREQUENCY_SUCCESS:
            return { ...state, urlsFrequency: action.payload }
        default:
            return state;
    }
};




